'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regexps = require('./regexps');

exports.default = function (str) {
  return _regexps.link.test(str);
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/linkhunter/lib/isLinkish.js
 ** module id = 110
 ** module chunks = 0
 **/